import http from "./http"
const CONVERT_POINTS_PATH = "/api/users/me/points"

export default {
  async convertPoints(code) {
    const { data: result } = await http.delete(CONVERT_POINTS_PATH)
    return result
  }
}
